import React from 'react'
import ProkrayaLanding from './ProkrayaLanding'
import Benifits from './Benifits'
import Products from './Products'
import WhyProkraya from './WhyProkraya'
import LogoScrollComponent from './LogoScroll'
import ContactForm from '../../../ContactForm/ContactUs'
import { useRef } from 'react'
const Prokraya = () => {
  const contact = useRef(null)
  return (
    <div>
          <section>
              <ProkrayaLanding contact={ contact} />
          </section>
          
          <section>
              <Benifits />
          </section>

          <section>
                <Products />
          </section>

           <section>
               <WhyProkraya />
            </section>
    
            <section>
                <LogoScrollComponent />
      </section>
      
      <section>
        <ContactForm ref={ contact} />
      </section>

    </div>
  )
}


export default Prokraya
